import { isWeb } from "./utils";

// export default {
// 	SessionDuration: 60,
// 	// CIP_BRAND: "incentivestagingxiaomi.foneworx.co.za",
// 	// CIP_BRAND: isWeb()
// 	// 	? window.location.hostname
// 	// 	: "incentivestaginghisense.foneworx.co.za",
// 	CIP_BRAND: "incentivestagingvivo.foneworx.co.za",
// 	XiaomiURL: "incentivestagingxiaomi.foneworx.co.za",
// 	Localhost: "localhost",
// 	Localhost2: "172.16.16.58",
// 	VivoURL: "incentivestagingvivo.foneworx.co.za",
// 	HisenseURL: "incentivestaginghisense.foneworx.co.za",
// 	WindowHostname: isWeb()
// 		? window.location.hostname
// 		: "incentivestagingvivo.foneworx.co.za",
// };

export default {
	SessionDuration: 60,
	CIP_BRAND: window.location.hostname,
	// CIP_BRAND: "www.vivoincentives.co.za",
	XiaomiURL: "www.xiaomiincentives.co.za",
	VivoURL: "www.vivoincentives.co.za",
	// Localhost: "localhost",
	WindowHostname: isWeb()
		? window.location.hostname
		: "www.vivoincentives.co.za",
};
